import React from 'react';
import cx from 'classnames';
import { makeStyles } from '../../../theme';
import { ExpandMore } from '../../icons';
import Box, { HORIZONTAL } from '../../layout/box';
import Text from '../../text';
import Accordion, { AccordionSummary } from '../../layout/accordion';
import Types, { getValueType } from '../types';
import EditableFields from './fieldedit';
import ObjZoomIn from './obj-zoom/in';
import { getDataDescLabel } from './util';

const styles = makeStyles(
	({ spacing }) => ({
		fieldsbox: {
			paddingLeft: spacing(2),
			paddingRight: spacing(2),
			paddingBottom: spacing(2)
		},
		objectBox: {
			marginBottom:spacing(2)
		},
		summeryBox: {
			justifyContent: 'space-between',
			width: '100%'
		}
	})
);

function getObjectFields(subject) {
	return Object.keys(subject).map((key => ({key, type:getValueType(subject[key]) ,value:subject[key]})));
}

function getArrayFields(subject) {
	return subject.map(((value, i) => ({key:i, type:getValueType(value) ,value:value})));
}

function getFields(subject, type) {
	return type === Types.array ? getArrayFields(subject) : getObjectFields(subject);
}

const ObjectEditContainer = React.memo(
	({ label='Value:', collapsible = true, value, onFieldActionRequest, dataPath, className, objZoomed, onObjZoomRequest, dataDescriptor }) => {
		const classes = styles();
		const vType = getValueType(value);

		const handleObjZoomIn = event => {
			event.stopPropagation(); // To stop event propagation to accordian.
			onObjZoomRequest(dataPath, true);
		}

		const handleObjZoomOut = (path = '') => {
			onObjZoomRequest(path, !!path);
		}

		const fields = (
			<EditableFields 
				parentType={vType} 
				fields={getFields(value)} 
				onFieldActionRequest={onFieldActionRequest} 
				dataPath={dataPath}
				objZoomed={objZoomed}
				onObjZoomRequest={onObjZoomRequest}
				onObjZoomOut={handleObjZoomOut}
				dataDescriptor={dataDescriptor}
			/>
		);

		return collapsible ? (
			<Accordion className={cx(className, classes.objectBox)}>
				<AccordionSummary  expandIcon={<ExpandMore />}>
					<Box type={HORIZONTAL} className={classes.summeryBox}>
						<Text component="span">{getDataDescLabel(dataDescriptor, value) || label}</Text>
						<ObjZoomIn onClick={handleObjZoomIn} />
					</Box>
				</AccordionSummary>
				<Box className={cx(classes.fieldsbox)}>
					{fields}
				</Box>
			</Accordion>
		) : fields;
	}
);

export default ObjectEditContainer;